import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './ConstructionAlreadyCommencedComponent.metadata.json5';

import styles from '../BuildersRisk.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function ConstructionAlreadyCommencedComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ConstructionAlreadyCommencedComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = _.get(submissionVM.value, 'lobData.consTraAndServLine.coverables.buildersRisk.project.hasTheProAlrStaFie')

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        pleexpFie1: {
            visible: !_.isUndefined(modelVM.havthebeeanyincontlosFie.value) && modelVM.havthebeeanyincontlosFie.value
        },
        pleExp2Fie: {
            visible: !_.isUndefined(modelVM.areTheAnyBuiLieOntProFie.value) && modelVM.areTheAnyBuiLieOntProFie.value
        },
        pleExp3Fie: {
            visible: !_.isUndefined(modelVM.anyChaInTheFinStaoOwnFie.value) && modelVM.anyChaInTheFinStaoOwnFie.value
        }

        
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ConstructionAlreadyCommencedComponent.propTypes = wizardProps;
export default withRouter(ConstructionAlreadyCommencedComponent);
